/**
 * Centralized API error message extraction for admin module.
 * Ensures consistent, user-friendly error handling across all hooks.
 */
import { AxiosError } from 'axios';

export function getErrorMessage(error: unknown, fallback = 'An unexpected error occurred'): string {
  if (error instanceof AxiosError) {
    const data = error.response?.data as Record<string, unknown> | undefined;
    const msg = data?.error ?? data?.message ?? data?.detail;
    if (typeof msg === 'string') return msg;
    if (Array.isArray(msg) && msg[0]?.msg) return String(msg[0].msg);
    if (error.response?.status === 400) return 'Invalid request. Please check your input and try again.';
    if (error.response?.status === 404) return 'Resource not found.';
    if (error.response?.status) return `Request failed (${error.response.status}). Please try again.`;
  }
  return error instanceof Error ? error.message : fallback;
}
